import { CalculatorCurrencyField } from '@components/common/CalculatorCurrencyField/CalculatorCurrencyField';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { OtherIncomeQuestions } from './quesions';
import { OtherIncomeProps } from './types';
import { useFormContext } from 'react-hook-form';
import { getValidatePeriodFunc } from '../../../../common/helpers';

export const OtherIncome: FC<OtherIncomeProps> = ({ applicantNumber }) => {
  const intl = useIntl();
  const { maintenanceIncome, pensionIncome, rentalIncome, error } = OtherIncomeQuestions;
  const errorMessage = intl.formatMessage({ id: error.required });
  const { watch } = useFormContext();

  const maintenanceIncomeName = maintenanceIncome.getFieldName(applicantNumber);
  const pensionIncomeName = pensionIncome.getFieldName(applicantNumber);
  const rentalIncomeName = rentalIncome.getFieldName(applicantNumber);

  const maintenanceIncomeValue = watch(maintenanceIncomeName);
  const pensionIncomeValue = watch(pensionIncomeName);
  const rentalIncomeValue = watch(rentalIncomeName);

  return (
    <div>
      <h3 className={'font-satoshi-black text-dark text-1-5xl xs:mb-5 m-0 font-black md:mb-10'}>
        <FormattedMessage id={'affordabilityCalculator.otherIncome.title'} />
      </h3>

      <CalculatorCurrencyField
        name={maintenanceIncomeName}
        titleKey={maintenanceIncome.titleKey}
        textKey={maintenanceIncome.textKey}
        periodProps={{
          options: maintenanceIncome.periodOptions,
          rules: { validate: getValidatePeriodFunc(maintenanceIncomeValue, errorMessage) },
        }}
        className={'xs:mb-5 md:mb-10'}
        isPeriod
      />
      <CalculatorCurrencyField
        name={pensionIncomeName}
        titleKey={pensionIncome.titleKey}
        textKey={pensionIncome.textKey}
        textHref={pensionIncome.textHref}
        periodProps={{
          options: pensionIncome.periodOptions,
          rules: { validate: getValidatePeriodFunc(pensionIncomeValue, errorMessage) },
        }}
        className={'xs:mb-5 md:mb-10'}
        isPeriod
      />
      <CalculatorCurrencyField
        name={rentalIncomeName}
        titleKey={rentalIncome.titleKey}
        textKey={rentalIncome.textKey}
        periodProps={{
          options: rentalIncome.periodOptions,
          rules: { validate: getValidatePeriodFunc(rentalIncomeValue, errorMessage) },
        }}
        className={'xs:mb-6 md:mb-12'}
        isPeriod
      />
      <hr className={'border-fog xs:mb-6 border border-t-0 border-solid md:mb-12'} />
    </div>
  );
};
